import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useTheme = (): IGlobalStore['theme'] => {
  return useSelector((store: IReducerStore) => store.global.theme);
};
